













import Vue from "vue";
import Component from "vue-class-component";
import { mask } from 'vue-the-mask';

@Component({
    directives: {
        mask,
    }
})
export default class DadosTelefone extends Vue {

    public telMask = '#####-####';

    get telefone () {
        return this.$store.state.cotacao.telefone;
    }

    set telefone ( value ) {
        // console.log('set: ' + value);
        const firstChar = value.substring(0, 1);
        if (value.length >= 10 && firstChar !== '9' ) {
            setTimeout( () => {
                this.$store.commit("SET_DDD", value.substring(0, 2));
                this.$store.commit("SET_TELEFONE", value.substring(2));
            }, 100);
        } else {
            this.$store.commit("SET_TELEFONE", value);
        }
    }

    get errorTelefone () {
        return this.$store.state.errors.telefone;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
